import React, { PropTypes, Component } from "react";
import ReactDOM from "react-dom";
import {
  NitroText,
  NitroButton,
  NitroIcon,
  NitroContentNotAvailable,
  NitroLoading
} from "nitro-components";

import styled, { keyframes } from "styled-components";

import * as ROUTES from "../../../routes/const";

import { media } from "style-utils";

import NotificationMessage from "./NotificationMessage";

const transitionIn = keyframes`
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Container = styled.div`
  position: absolute;
  max-height: 700px;
  width: 350px;
  top: 50px;
  left: -142px;
  z-index: 10;
  background: ${props => props.theme.color.white};
  box-shadow: 0 2px 4px 0 rgba(0,0,0,0.15);
  z-index: 1;
  opacity: 0;
  transform: translateY(10px);
  animation-name: ${transitionIn};
  animation-duration: .3s;
  animation-fill-mode: forwards;
  animation-timing-function: ease-out;

  ${media.mobileTablet`
    position: static;
    height: 100%;
    width: 100%;
  `}

  &::after {
    bottom: 100%;
    left: 50%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-bottom-color: ${props => props.theme.color.notification};
    border-width: 15px;
    margin-left: -15px;

    ${media.mobileTablet`
        display: none;
    `}
  }
`;

const NotificationContent = styled.div`
  padding: 0 20px 10px 20px;
  padding-bottom: 20px;
  overflow-y: auto;
  max-height: 600px;
  min-height: 300px;

`;

const Settings = styled.section`
  float: right;
  opacity: 0.5;
  transition: opacity .3s;

  &:hover {
    opacity: 1;
  }

  ${media.mobileTablet`
      margin-right: 40px;
  `}
`;

const SettingsButton = styled.button`
  background: none;
  border: 0;
  cursor: pointer;
  outline: 0;
  padding: 0;
`;

const NotificationHeader = styled.div`
    background: ${props => props.theme.color.notification};
    height: 60px;
    padding: 20px;
`;

class NotificationPopUp extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      resetConfirm: false
    };
    this.viewReport = this.viewReport.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  /**Handle popup click - Close pop up when clicked outside**/
  componentDidMount() {
    document.addEventListener("click", this.handleClickOutside, true);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside, true);
  }

  handleClickOutside(e) {
    const domNode = ReactDOM.findDOMNode(this.notificationPopup);
    if (
      domNode &&
      e.target &&
      !domNode.contains(e.target) &&
      !domNode.contains(e.target.parent)
    ) {
      e.stopPropagation();
      this.props.closeNotification();
    }
  }

  /**Handle popup click ends- Close pop up when clicked outside**/

  gotoSettings = () => {
    this.context.router.push(ROUTES.NOTIFICATION_SETTINGS);
    this.props.closeNotification();
  };

  seeAllNotification = () => {
    this.context.router.push(ROUTES.NOTIFICATION_CENTER);
    this.props.closeNotification();
  };

  viewReport = reportParam => {
    this.context.router.push({
      pathname: `${ROUTES.NOTIFICATION_CENTER}`,
      query: reportParam
    });
    this.props.closeNotification();
  };

  render() {
    const { data, fetchingNotifications, onNotificationDelete } = this.props;
    return (
      <Container ref={ref => (this.notificationPopup = ref)}>
        <NotificationHeader>
          <NitroText size="2" variant="white" bold>
            {data && data.length > 0
              ? `${data.length} Notifications`
              : `Notifications`}
          </NitroText>
          <Settings>
            <SettingsButton onClick={this.gotoSettings}>
              <NitroIcon name="settings" size="16" right={6} variant="white" />
              <NitroText variant="white" size="4" bold>{`SETTINGS`}</NitroText>
            </SettingsButton>
          </Settings>
        </NotificationHeader>
        <NotificationContent>
          {fetchingNotifications && <NitroLoading />}

          {!fetchingNotifications &&
            data &&
            data.map((item, index) => {
              if (index >= 5) {
                return null;
              }

              return (
                <div key={index}>
                  <NotificationMessage
                    title={item.Title}
                    categoryName={item.CategoryName}
                    description={item.Description}
                    timeStamp={item.DaysToolText}
                    company={item.CompanyName}
                    keys={item.NotificationKeys}
                    displayDeleteFullWidth
                    condensed
                    midVariant
                    onClick={this.viewReport}
                    onDelete={onNotificationDelete}
                    reportParam={item.ReportParameters}
                    resetConfirm={this.state.resetConfirm}
                  />
                </div>
              );
            })}
          {data &&
            data.length > 5 &&
            !fetchingNotifications &&
            <NitroButton
              label="See all notifications"
              size="compact"
              width="block"
              block
              action={this.seeAllNotification}
            />}

          {data &&
            (!data.length > 0 &&
              !fetchingNotifications &&
              <NitroContentNotAvailable
                content="Everything’s looking good!"
                description="You have no new notifications"
                backgroundIndex={1}
              />)}
        </NotificationContent>
      </Container>
    );
  }
}

NotificationPopUp.propTypes = {
  action: PropTypes.func,
  data: PropTypes.array,
  closeNotification: PropTypes.func,
  actions: PropTypes.object,
  fetchingNotifications: PropTypes.bool,
  onNotificationDelete: PropTypes.func
};

NotificationPopUp.contextTypes = {
  router: PropTypes.object
};

export default NotificationPopUp;



// WEBPACK FOOTER //
// ./src/features/common/GlobalNotification/NotificationPopUp.js